export class ApplicationError {
    public readonly message: string;
    constructor(message: string) {
        this.message = message;
    }
}
